import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// PWA: vite-plugin-pwa handles SW registration automatically via registerType: "autoUpdate"
// Additional update check every 60s for Play Store compatibility
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    console.log("SW ativo:", registration.scope);
    setInterval(() => registration.update(), 60 * 1000);
  });

  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!refreshing) {
      refreshing = true;
      console.log("Service Worker atualizado, recarregando...");
      window.location.reload();
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);

